import {Carousel, Slide} from 'vue-carousel';

export default {
  data: {
    courses: [],
    micro_course: true,
    category: '',
    selectedCategory: '',
    categories: ['All', 'Visual Arts', 'Creative Computing', 'Music Technology', 'Design & Fashion', 'Film & Videography'],
    show_share_modal: false,
    share_modal_params: null,
    carousel: {
      course: { page_count: 0, first_page: false, last_page: false }
    }
  },

  components: {
    Carousel,
    Slide
  },

  watch: {
    selectedCategory() {
      this.courseFiltering(this.selectedCategory);
    }
  },

  methods: {
    bindData(data) {
      this.courses = data.courses;
    },

    makeRequest: _.memoize(function (url, loadingIndicator) {
      return new Kadenze.AjaxRequest({
        type: 'GET',
        url: url,
        loadingIndicator: loadingIndicator
      });
    }),

    updateCarouselNav(type = 'course') {
      this.carousel[type].page_count = this.$refs[`${type}Carousel`].pageCount;
      this.carousel[type].first_page = this.$refs[`${type}Carousel`].currentPage === 0;
      
      this.carousel[type].last_page = this.$refs[`${type}Carousel`].currentPage === (this.$refs[`${type}Carousel`].pageCount - 1);
    },

    navCarousel(type = 'course', action = 'next') {
      if (action === 'next')
        this.$refs[`${type}Carousel`].goToPage(this.$refs[`${type}Carousel`].getPreviousPage());
      else
        this.$refs[`${type}Carousel`].goToPage(this.$refs[`${type}Carousel`].getNextPage());
      this.updateCarouselNav(type);
    },

    showShareModal(params) {
      this.share_modal_params = params;
      this.show_share_modal = true;
    },

    courseFiltering(category) {
      Kadenze.UIUtil.showLoadingIndicator(this.$el, null, 'fixed')
      var selectedCategory = category;
      category = category.split('&')
      const req = new Kadenze.AjaxRequest({
        type: 'GET',
        url: Kadenze.Routes.category_courses_path({name: category})
      })

      req.done(courses => {
        this.bindData(courses)
        $('.next-arrow, .previous-arrow').show();
        $('.welcome-category').removeClass('active-category');

        var courseSize = courses.courses.length;

        if((courseSize <= 4 && !this.mobileView()) || (courseSize == 1 && this.mobileView())) {
          $('.next-arrow, .previous-arrow').hide();
        }

        var activeCategory = selectedCategory.replace(/[& ]/g,'_');
        $(`.${activeCategory}`).addClass("active-category");
      })

      req.fail(data => console.warn('error retrieving course data', data))

      req.always(data => {
        Kadenze.UIUtil.hideLoadingIndicator(this.$el)
      })

      return req
    },

    mobileView() {
      return screen.width < 361;
    }
  },

  mounted() {
    if (this.courses.length > 0)
      this.updateCarouselNav('course');
  }
}